.select {
  width: fit-content;
}
